import { render, staticRenderFns } from "./checkedlist.vue?vue&type=template&id=03deda44&scoped=true"
import script from "./checkedlist.vue?vue&type=script&lang=js"
export * from "./checkedlist.vue?vue&type=script&lang=js"
import style0 from "./checkedlist.vue?vue&type=style&index=0&id=03deda44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03deda44",
  null
  
)

export default component.exports